import { SITECODE, URL_CODE } from '@match/app-rules-resolver';
import {
  themeSurprisedCorgi,
  themeStir,
  themeFantasticLlama,
} from '@match/react-component-library';
import { Theme } from '@match/react-component-library/components/theme/types/theme';
import merge from 'lodash/merge';
import brands from './brands';

const inMemCache = {} as Record<string, Theme>;

export function getThemeForSite(
  sitecode: number,
  urlCode: number = URL_CODE.MATCH,
  themeName: string = 'surprisedcorgi'
) {
  let currentTheme;
  let baseTheme = themeSurprisedCorgi;
  const cacheKey = `${sitecode}-${urlCode}-${themeName}`;

  if (inMemCache[cacheKey]) {
    return inMemCache[cacheKey];
  }

  switch (themeName) {
    case 'fantasticllama': {
      baseTheme = themeFantasticLlama;

      break;
    }
  }

  switch (sitecode) {
    case SITECODE.STIR:
      currentTheme = merge({}, themeStir, brands.stir);

      break;
    case SITECODE.LAT_AM: {
      const latamBrand = getLatamBrandByUrlCode(urlCode);
      currentTheme = merge({}, baseTheme, latamBrand);
      break;
    }
    case SITECODE.JAPAN: {
      currentTheme = merge({}, baseTheme, brands.matchJapan);
      break;
    }
    default:
      currentTheme = merge({}, baseTheme, brands.match);
  }

  inMemCache[cacheKey] = currentTheme;

  return currentTheme;
}

export function getLatamBrandByUrlCode(urlCode: number) {
  switch (urlCode) {
    case URL_CODE.PAR_PERFEITO:
      return brands.parPerfeito;
    case URL_CODE.G_ENCONTROS:
      return brands.gEncontros;
    case URL_CODE.DIVINO_AMOR:
      return brands.divinoAmor;
    case URL_CODE.SINGLE_PARENT_MEET_BR:
      return brands.singleParentMeet;
    case URL_CODE.OUR_TIME_BR:
    case URL_CODE.OUR_TIME_MX:
    case URL_CODE.OUR_TIME_AR:
      return brands.ourTime;
    default:
      return brands.matchLatam;
  }
}
